import React from "react";
import { Container, Row, Col, NavLink, Button } from "react-bootstrap";
import logo_motobombas_blanco from "../images/logo_motobombas_blanco.png";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import avatar_motobombas from "../images/avatar_motobombas.png";

const About = () => {
  const titleStyle = {
    fontFamily: "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif",
    color: "#FAFAFA",
    fontSize: "36px",
    marginTop: "20px", // Añadir margen superior
    textAlign: "center", // Centrar el texto
  };

  const paragraphStyle = {
    fontFamily: "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif",
    color: "#FAFAFA",
    fontSize: "16px",
    textAlign: "justify",
    marginTop: "10px", // Añadir margen superior
  };

  return (
    <section id="about-us" style={{ marginTop: "20px", backgroundColor: "#2D4E76" }}>
      {" "}
      {/* Añadir margen superior al contenedor principal */}
      <Container>
        <Row>
          <Col md={6}>
            <img
              src={logo_motobombas_blanco}
              alt="Imagen de la empresa"
              className="img-fluid"
              style={{ width: "100%", height: "auto" }}
            />
          </Col>
          <Col md={6} className="text-center">
            <h2 style={titleStyle}>Sobre Nosotros</h2>
            <p style={paragraphStyle} className="text-justify">
              Motobombas C.A. es una empresa líder en la fabricación y
              distribución de motobombas de alta calidad y rendimiento. Con un
              enfoque en la excelencia y la innovación, ofrecemos soluciones
              confiables y eficientes para diversas industrias. Nuestra amplia
              gama de productos, respaldada por un excelente servicio al
              cliente, garantiza la satisfacción de nuestros clientes. Nos
              preocupamos por el medio ambiente y nos esforzamos por ser
              sostenibles en todas nuestras operaciones. Elija Motobombas C.A.
              para obtener calidad, confiabilidad y compromiso en cada producto
              que ofrecemos. ¡Contáctenos hoy y descubra cómo podemos ayudarlo a
              alcanzar sus objetivos!
            </p>
            <Col md={12} className="text-center">
              <div className="embed-responsive embed-responsive-16by9">
                <iframe
                  width="100%"
                  height="315"
                  className="embed-responsive-item"
                  src="https://www.youtube.com/embed/jNIXngzc33c"
                  title="Video sobre nosotros"
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              </div>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const Contacto = () => {
  const buttonStyle = {
    backgroundColor: '#2D4E76',
    borderColor: '#2D4E76', // Color del borde
  };

  return (
    <Container className="d-flex justify-content-center" style={{ marginTop: "auto" }}>
      <Button variant="light" className="m-2" style={buttonStyle}>
        <NavLink href="https://wa.me/584244024689">
          <WhatsAppIcon fontSize="large" style={{ color: '#FAFAFA' }} />
        </NavLink>
      </Button>
      <Button variant="light" className="m-2" style={buttonStyle}>
        <NavLink href="https://instagram.com/motobombasca?igshid=ZDc4ODBmNjlmNQ==">
          <InstagramIcon fontSize="large" style={{ color: '#FAFAFA' }} />
        </NavLink>
      </Button>
      <Button variant="light" className="m-2" style={buttonStyle}>
        <NavLink href="https://www.google.com/maps/place/Motobombas,+C.A.+Sede+Principal/@10.1984189,-67.9175419,17z/data=!3m1!4b1!4m6!3m5!1s0x8e80679603cd1def:0x897bd1f33654eda4!8m2!3d10.1984189!4d-67.9175419!16s%2Fg%2F11d_9hj8zl">
          <FmdGoodIcon fontSize="large" style={{ color: '#FAFAFA' }} />
        </NavLink>
      </Button>
    </Container>
  );
};


const Footer = () => {
  return (
    <div
      style={{
        marginTop: "auto", // Hace que el Footer siempre esté al final
        backgroundColor: '#2D4E76',
        color: "#FAFAFA",
        textAlign: "center",
        padding: "10px", // Puedes ajustar el padding según tus necesidades
      }}
    >
      © 2023 Motobombas C.A.
    </div>
  );
};

const AboutUs = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", backgroundColor: "#2D4E76", minHeight: "100vh" }}>
      <About style={{ flex: "1" }} />
      <Contacto />
      <Footer />
      <FloatingWhatsApp 
        phoneNumber="+584244024689" 
        accountName="Motobombas,c.a." 
        chatMessage="Hola!, Bienvenido a Motobombas,c.a. ¿Como podemos ayudarte? "
        avatar= {avatar_motobombas}
        statusMessage="Fabricantes de Bombas de agua"
        />
    </div>
  );
};

export default AboutUs;